import React, { useState } from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
// import StyledButton from '../../../../common/models/Button';
import Button from "@material-ui/core/Button";
import SystemUpdateAltIcon from "@material-ui/icons/SystemUpdateAlt";
// import DropFilesAttach from '../models/files/DropFilesAttach';
import { Dialog, MenuItem, Select, TextField } from "@material-ui/core";
import DropFilesAttach from "../../../../models/files/DropFilesAttach";
import StyledButton from "../../../../models/Button";
import StyledDialog from "../../../../../../../common/models/Dialog";
import BackDropLoading from "../../../../models/BackDrop";
import axios from "axios";
import { appUrl } from "../../../../../../../../utils/config";
import {
  DESTROY_BACKDROP,
  OPEN_BACKDROP,
} from "../../../../../../containers/actions/types";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  document: {
    display: "flex",
    alignItems: "center",
    padding: "1.5rem",
    paddingTop: "0rem",
  },
  button: {
    textTransform: "none",
    border: "1px solid #000000",
    borderRadius: "2rem",
    padding: "0.5rem 2rem",
    "&:hover": {
      backgroundColor: "black",
      color: "white",
    },
  },

  closeText: {
    display: "flex",
    alignItems: "center",
    color: "blue",
    textDecoration: "underline",
  },
  validate: {
    padding: "1rem",
  },
  buttonGrid: {
    paddingTop: "2rem",
    textAlign: "center",
  },
  dropzone: {
    padding: "1.25rem",
  },
  select: {
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  backgroundGrid: {
    backgroundColor: "#ffffff",
    borderRadius: "1rem",
  },
}));
const UploadRecordFiles = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    batchDetails,
    schrockenDeliveryScheduleID,
    handleClose,
    handleFetchCall,
  } = props;

  const [state, setState] = useState({
    disableNext: false,
    errors: {},
    uploadedRecordsFileName: "",
    uploadedRecordsFiles: {},
    resError: null,
    confirmDialog: false,
    errorMessageColor: "black",
  });
  const FileHandling = (files) => {
    files.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        if (file.size > 20000000) {
          setState({
            errors: {
              errorStatus: true,
              resError:
                "File(s) size limit exceeded. Please attach file(s) size less than 20MB",
            },
          });
          setTimeout(() => this.scrollToTop(), 100);
        } else {
          setState({
            ...state,
            uploadedRecordsFileName: file.name,
            uploadedRecordsFiles: reader.result,
            errors: {},
          });
        }
      };
    });
  };

  const handleDeleteRecord = () => {
    setState({
      ...state,
      uploadedRecordsFiles: {},
      uploadedRecordsFileName: "",
      resError: null,
      errors: {},
    });
  };

  const handleUpload = () => {
    setState({ ...state, disableNextButton: true, errorMessageColor: "black" });
    dispatch({
      type: OPEN_BACKDROP,
      backdropText: "Please wait. Updating....",
    });

    if (Object.keys(state.uploadedRecordsFiles).length !== 0) {
      let data = {
        fileData: state.uploadedRecordsFiles,
        fileType: "CONSUMPTIONDETAILS",
        fileName: state.uploadedRecordsFileName,
        vendorMosymphonyID: batchDetails.vendorMosymphonyID,
        vendorBatchNumber: batchDetails.vendorBatchNumber,
        schrockenDeliveryScheduleBatchID:
          batchDetails.schrockenDeliveryScheduleBatchID,
        schrockenDeliveryScheduleID: schrockenDeliveryScheduleID,
        cdmoOrgID: batchDetails.vendorMosymphonyID,
        sponsorOrgID: batchDetails.brandOwnerMosymphonyID,
      };

      axios
        .post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/dataExtractionTrigger`,
          data
        )
        .then((res) => {
          //console.log(res);
          setState({
            ...state,
            confirmDialog: true,
          });

          dispatch({
            type: DESTROY_BACKDROP,
          });
        })
        .catch((err) => {
          dispatch({
            type: DESTROY_BACKDROP,
          });
          setState({
            errors: {
              errorStatus: true,
              resError: "Something went wrong. Please try again later.",
            },
          });

          console.log(err);
        });
    } else {
      dispatch({
        type: DESTROY_BACKDROP,
      });
      setState({
        ...state,
        errorMessageColor: "red",
      });
    }
  };

  const handleCloseRecord = () => {
    setState({
      ...state,
      confirmDialog: false,
    });
    handleClose();
    handleFetchCall();
  };
  const [fileType, setFileType] = useState(".pdf");

  const fileTypes = [
    // { label: "none", value: "none", disable:false },
    // { label: ".xls", value: ".xls", disable:true },
    // { label: ".xlsx", value: ".xlsx", disable:true },
    { label: ".pdf", value: ".pdf", disable: false },
    // { label: ".xml", value: ".xml", disable:true },
  ];

  return (
    <React.Fragment>
      <BackDropLoading />
      <Grid container justifyContent="center">
        <Grid
          item
          xs={11}
          sm={10}
          md={12}
          lg={12}
          xl={12}
          className={classes.backgroundGrid}
        >
          <Grid container justifyContent="center">
            <Grid item xs={12} md={9} lg={8} xl={6}>
              <Grid container justifyContent="center">
                {state.errors?.errorStatus === true && (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    className={classes.dropzone}
                  >
                    <Typography
                      variant="h6"
                      style={{
                        border: "1px solid #FF0000",
                        backgroundColor: "#FFF0F0",
                        opacity: "1",
                        textAlign: "center",
                        padding: "0.8rem",
                        fontSize: "0.875rem",
                      }}
                    >
                      {state.errors?.errMsg}
                    </Typography>
                  </Grid>
                )}
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.dropzone}
                >
                  <DropFilesAttach
                    handleUploadFiles={FileHandling}
                    singleFile
                    acceptedFileExtns={fileType}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.validate}
                >
                  <Grid item>
                    <Typography
                      style={{ fontWeight: 500, paddingLeft: "1.2rem" }}
                      variant="body1"
                    >
                      Select file type:
                    </Typography>
                    <TextField
                      select
                      // label="File Type"
                      value={fileType}
                      onChange={(e) => setFileType(e.target.value)}
                      variant="outlined"
                      style={{ paddingLeft: "1.2rem", marginTop: "5px" }}
                      margin="normal"
                      InputProps={{
                        classes: {
                          input: classes.select, // Apply custom padding
                        },
                      }}
                    >
                      {fileTypes.map((type) => (
                        <MenuItem
                          key={type.value}
                          value={type.value}
                          disabled={type.disable}
                        >
                          {type.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  {state.uploadedRecordsFileName !== "" ? (
                    <Typography variant="body2" className={classes.document}>
                      <span
                        key={state.uploadedRecordsFileName}
                        className={classes.closeText}
                        style={{ paddingBottom: "0.5rem" }}
                      >
                        {state.uploadedRecordsFileName}
                        <CloseIcon
                          fontSize="small"
                          color="error"
                          style={{ paddingLeft: "0.5rem", cursor: "pointer" }}
                          onClick={() => handleDeleteRecord()}
                        />
                        <br />
                      </span>
                    </Typography>
                  ) : (
                    <Typography
                      variant="body2"
                      style={{ color: state.errorMessageColor }}
                      className={classes.document}
                    >
                      -No Documents Uploaded-
                    </Typography>
                  )}
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  xl={12}
                  className={classes.buttonGrid}
                >
                  <StyledButton
                    size="small"
                    onClick={handleUpload}
                    disabled={state.disableNextButton}
                    style={{
                      paddingLeft: "4rem",
                      paddingRight: "4rem",
                      paddingTop: "0.5rem",
                      paddingBottom: "0.5rem",
                    }}
                  >
                    Upload
                  </StyledButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Dialog open={state.confirmDialog} fullWidth>
        <StyledDialog
          handleClose={handleCloseRecord}
          icons={true}
          title="Details Saved Successfully"
          // subtitle='Your Record has been added/updated.Please Contact the Admin if you have Entered the Wrong Data.'
        />
      </Dialog>
    </React.Fragment>
  );
};
export default UploadRecordFiles;
